// @ts-strict-ignore
import { IStock } from '../../model/stock';
import { EconomicStockImpactType } from '../../model/climate-cortex-model';
import { KeyMap } from '../key-map';
import { Variable } from '../variable/variable';

export class Stock {
  private _averageUtilisation?: number;
  private _initialStock?: number;
  private _lifespanUtilisation?: number;
  private _lifespanYears?: number;

  constructor(value: IStock, variables: KeyMap<Variable>) {
    this._lifespanUtilisation = variables[value.lifespanUtilization]?.value;
    this._lifespanYears = variables[value.lifespanYears]?.value;
    this._averageUtilisation = variables[value.averageUtilization]?.value;
    this._initialStock = variables[value.initialStock]?.value;
  }

  getStockAmount(
    initialOperations: number,
    operations: number,
    economicStockImpact: EconomicStockImpactType = EconomicStockImpactType.Full
  ): number {
    if (economicStockImpact === EconomicStockImpactType.None) {
      return 0;
    } else if (this._averageUtilisation !== undefined) {
      return operations / this._averageUtilisation;
    } else if (this._initialStock !== undefined) {
      const averageUtilisation = initialOperations / this._initialStock;
      return operations / averageUtilisation;
    }
    return 1;
  }

  getStockInflow(
    initialOperations: number,
    shiftedOperations: number,
    economicStockImpact: EconomicStockImpactType = EconomicStockImpactType.Full
  ): { realInflow: number; inflowDelta: number } {
    if (this._averageUtilisation !== undefined) {
      let averageLifetime;
      if (this._lifespanUtilisation !== undefined) {
        averageLifetime = this._lifespanUtilisation / this._averageUtilisation;
      } else if (this._lifespanYears) {
        averageLifetime = this._lifespanYears;
      }
      const initialStock = initialOperations / this._averageUtilisation;
      const averageOutflow = initialStock / averageLifetime;
      const realInflow =
        economicStockImpact === EconomicStockImpactType.Full
          ? Math.max(0, averageOutflow + shiftedOperations / this._averageUtilisation)
          : averageOutflow;
      const inflowDelta = realInflow - averageOutflow;
      return { realInflow, inflowDelta };
    } else if (this._initialStock !== undefined) {
      //TODO Note: when this is implemented, give heed to how this works in relation to TEs that have economic stock impact none
    }
    return { realInflow: 1, inflowDelta: 0 };
  }
}
